import React, { useEffect, useState } from "react";
import "./SquareCard.css";
import dataArray from "./squareData";
import RecCard from "../RecCard/RecCard";
import { platform } from "../Config/Helper";
import nonselect from "../images/nonselect.webp"
import selectdone from "../images/selectedone.webp"

const SquareCard = () => {
  const platformdata = JSON.parse(localStorage.getItem("platform"))
  const appdata = JSON.parse(localStorage.getItem("appFeatures"))

  const [iscardChecked, SetIsCardChecked] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
  });

  const handleOnClick = (index, name) => {
    SetIsCardChecked({
      ...iscardChecked,
      [index]: iscardChecked[index] === true ? false : true,
    });

    platform(name);
  };

  let isSelectedCard = [];
  for (let i = 0; i < 4; i++) {
    isSelectedCard.push(iscardChecked[i]);
  }

  useEffect(() => {
    localStorage.removeItem("appFeatures");
    localStorage.removeItem("platform");
  }, []);



  return (
    <div>
      <div className="cards-box">
        {dataArray.map((data, index) => {
          return (
            <div
              className={`card-container${
                iscardChecked[index] === true ? "active" : ""
              }`}
              onClick={() => handleOnClick(index, data.logoText)}
            >
              <div
                key={index}
                className={`individual-card${
                  iscardChecked[index] === true ? "active" : ""
                }`}
              >
                <div className="navlogo">
                  <span className="logo-text">{data.logoText}</span>
                  <img
                    className="navimg"
                    src={
                      iscardChecked[index] == true
                        ? selectdone
                        : nonselect
                    }
                    alt=""
                  />
                </div>
                {/* <span className="logo-text">{data.logoText}</span> */}
                <div className="image-container">
                  <img src={data.imageSrc2} alt="Image" className="image" />
                </div>
                <p
                  className={`text-below-image${
                    iscardChecked[index] === true ? "active" : ""
                  }`}
                >
                  {data.textBelowImage}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      {isSelectedCard.includes(true) ? <RecCard /> : null}

     
    </div>
  );
};

export default SquareCard;
